import { getAPIURL } from "./config";

/**
 * GET /sketch_design/accumulations/reserves/all
 */
export const getSketchDesignAccumulationsReservesAll = async () => {
  const response = await fetch(
    `${getAPIURL()}sketch_design/accumulations/reserves/all`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "include",
    }
  );
  if (!response.ok) {
    const text = await response.text();
    throw new Error(
      text || `Не удалось загрузить резервы (${response.status})`
    );
  }
  const data = await response.json();
  return Array.isArray(data) ? data : [];
};

/**
 * GET /sketch_design/accumulations/deviations/all
 */
export const getSketchDesignAccumulationsDeviationsAll = async () => {
  const response = await fetch(
    `${getAPIURL()}sketch_design/accumulations/deviations/all`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "include",
    }
  );
  if (!response.ok) {
    const text = await response.text();
    throw new Error(
      text || `Не удалось загрузить отклонения (${response.status})`
    );
  }
  const data = await response.json();
  return Array.isArray(data) ? data : [];
};
